import {createSelector} from '@ngrx/store';
import {AppState} from '../states/app.state';

export class NaseDialogSelectors {
  private static select = {
    naseDialog: (state: AppState) => state.naseDialog,
  };

  public static isNaseDialogOpen = createSelector(this.select.naseDialog, data => data?.isOpen ?? false);
}
